import { useQuery } from 'react-query'
import { customersByIds } from 'services/cm-api/customers-by-ids'

/**
 * Hydrates labels for a known set of customer ids — used by the
 * banner edit-mode dialog to resolve `target_customer_ids` chips
 * back to their `local_id — name` from the placeholder.
 *
 * The cache key is the sorted comma-joined id list so two callers
 * passing the same ids in different order share the same cache entry.
 * `enabled` is gated on the id list being non-empty (no point round-
 * tripping for nothing) and on a Firebase token being present.
 */
export function useCustomersByIds(ids: number[]) {
  const sorted = [...ids].sort((a, b) => a - b)
  const cacheKey = sorted.join(',')

  return useQuery(
    ['customers-by-ids', cacheKey],
    () => customersByIds(sorted),
    {
      enabled:
        sorted.length > 0 && Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      // Customer name/local_id rarely changes inside an editing
      // session — once we've resolved a chip's label, keep it.
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  )
}
